import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-editor-media',
    templateUrl: './editor-media.component.html',
    styleUrls: ['./editor-media.component.scss'],
    standalone: false
})
export class EditorMediaComponent implements OnInit {

  _model;
  @Input() set model(model){
    this._model = model;
    if(!this._model.data){
      this._model.data = {};
    }
    console.log('model:'+JSON.stringify(model));
    if(!this._model.data.fileURL && Object.keys(model.data).length > 0){
      this.type = 'language_specific';
    }
  };
  @Input() gameId;
  @Input() templateId;

  @Input() languages;
  @Input() defaultLang;

  type = 'single';

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  async imageUpdated(lang, data){
    if(data){
      if(lang){
        console.log('imageUpdated:'+lang);
        this._model.data[lang] = {
          fileURL: data.fileURL
          //filePath: data.filePath,
          //lastUpdate: data.lastUpdate
        };
      }
      else{
        console.log('single imageUpdated');
        this._model.data = {
          fileURL: data.fileURL
          //filePath: data.filePath,
          //lastUpdate: data.lastUpdate
        };
      }
      //await this.characterService.updateCharacter(this._model, {fileURL:data.fileURL, filePath:data.filePath, lastUpdate:data.lastUpdate});
    }
  }

}
